interface ErrorResponseLike {
  text: () => Promise<string>;
  headers: { get: (name: string) => string | null };
}

export const parseErrorResponseBody = async (response: ErrorResponseLike): Promise<unknown> => {
  const text = await response.text();

  try {
    return JSON.parse(text);
  } catch {
    const isHtml = (response.headers.get('Content-Type') ?? '').toLowerCase().includes('html');
    return text.trim() && !isHtml ? { errorDetails: { detail: text.trim() } } : text;
  }
};
